module.exports = __webpack_public_path__ + "partner-2.jpg?127bc0207061797b5a3247b0c43cf7ef";